import { useState } from 'react';
import Nav from './components/Nav';
import Footer from './components/Footer';
import WhatsAppButton from './components/WhatsAppButton';
import Home from './pages/Home';
import Servicios from './pages/Servicios';
import Productos from './pages/Productos';
import Contacto from './pages/Contacto';

export default function App() {
  const [page, setPage] = useState('inicio');

  const goTo = (p) => {
    setPage(p);
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  return (
    <>
      <Nav currentPage={page} goTo={goTo} />
      <main>
        {page === 'inicio'    && <Home goTo={goTo} />}
        {page === 'servicios' && <Servicios />}
        {page === 'productos' && <Productos />}
        {page === 'contacto'  && <Contacto />}
      </main>
      <Footer goTo={goTo} />
      <WhatsAppButton />
    </>
  );
}
